module.exports = __webpack_public_path__ + "images/goit-students-photos/Bogdan.jpg";